import { REMIX_SUPPORTED_FONTS } from 'shared/constants/fonts'

export const getRemixFontsList = (asSelectOptions = false) => {
    if (asSelectOptions) return REMIX_SUPPORTED_FONTS.sort().map(font => ({ value: font, label: font }))
    return REMIX_SUPPORTED_FONTS.sort()
}
